import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { FilterService } from '../../../core/services/core.filter.service';
import { FrsReleaseHelper } from '../services/frs.release.helper.service';
import { FrsReleaseService } from '../services/frs.release.service';
import { FrsPackageService } from '../services/frs.package.service';
import { PackageModelService } from '../services/frs.package.model.service';
import { StateService } from '@uirouter/angular';
import { ReleaseModel } from '../services/frs.release.model.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GfTitleService } from '../../../core/services/core.title.service';
import { GfTranslateService } from '../../../core/services/core.translate.service';
import { FrsReleaseFilesComponent } from '../frsFiles/frs.files.component';
import { FrsPackageEditComponent } from '../frsPackageEdit/frs.package.edit.component';
import { FrsReleaseEditComponent } from '../frsReleaseEdit/frs.release.edit.component';

@Component({
    selector: 'frs-browse',
    template: require('./frs.browse.html')
})
export class FrsBrowseComponent implements OnInit {

    @Input() project: any = null;
    @Input() projectMenu: any = null;

    //Variable initializations
    private showPackageEditModal = false;
    protected sortFields = {};
    private sort: any = {};
    private paging: any = {};
    private currentPackage = null;
    protected downloadFile = null;
    private currentUser = null;
    protected breadcrumbs = null;
    protected showEditPackageIcon: any;
    protected showAddPackageButton = false;
    private baseFilters: any = {};
    protected filters = { main_fields: [] };
    protected releases: any = false;
    private projectPackages: any = false;
    protected recentReleases: any = false;
    protected anyFiltersSet = false;
    protected showIDs = false;
    protected isAdmin = false;
    protected showFilters = true;
    protected collapsed = true;

    constructor(
        private filterService: FilterService,
        private frsReleaseHelper: FrsReleaseHelper,
        private frsReleaseService: FrsReleaseService,
        private frsPackageService: FrsPackageService,
        private packageModel: PackageModelService,
        private stateService: StateService,
        private releaseModel: ReleaseModel,
        private window: Window,
        private modalService: NgbModal,
        protected gfTranslateService: GfTranslateService,
        private titleService: GfTitleService,
    ) {}

    ngOnInit(): void {
        this.isAdmin = (_.get(this.project, 'rel.permissions.admin', false) || _.get(this.project, 'rel.permissions.frs', 0) >= 99);
        this.sortFields = this.frsReleaseHelper.browse.getSortFields();
        this.sort = this.filterService.getSortValues();
        this.paging = this.filterService.getPagingValues();
        //Add functions to be made available on the view
        this.downloadFile = this.frsReleaseHelper.display.openDownload.bind(this.frsReleaseHelper.display);

        this.currentUser = this.filterService.currentUser();
        this.breadcrumbs = this.frsReleaseHelper.display.breadcrumbsFor(this.project);

        this.titleService.setTitle(this.project.name, 'Releases');

        var promises = [
            this.packageModel.setAcl(
                _.get(this.currentUser, 'unixName', ''),
                _.get(this.stateService.params, 'unixName', '')
            ),
            this.frsPackageService.fetch(
                this.stateService.params.unixName
            )
        ];

        Promise.all(promises)
            .then((results) => {
                const [acl, projectPackages] = results;
                this.projectPackages = _.get(projectPackages, 'items', []);

                this.showEditPackageIcon = _.memoize(
                    (pkg: any) => {
                        return this.packageModel.acl.isAdmin(pkg);
                    }, function (a) { return a ? a : '_default'; });
                this.showAddPackageButton = this.packageModel.acl.canSubmit();

                this.baseFilters = this.frsReleaseHelper.browse.getBaseFilters(
                    this.projectPackages,
                    this.packageModel.acl.canSubmit()
                );

                this.setFilterValues();
                this.getRecentReleases();
                this.getReleases();
            });
    }

    onApplyFilters (event?: any) {
        this.paging.page_num = 1;
        this.applyFilters();
    };

    onResetFilters (event?: any) {
        this.paging.page_num = 1;
        this.filters = {
            main_fields: this.baseFilters
        };
        this.applyFilters();
    };

    setSort (params: any) {
        this.sort = {
            sort_field: _.get(params, 'key', 'releaseDate'),
            sort_dir: _.get(params, 'sortDir', 'desc')
        };
        this.applyFilters();
    };

    onPaging (params) {
        _.assignIn(this.paging, params);
        this.applyFilters();
    };

    toggleIDs () {
        this.showIDs = !this.showIDs;
    };

    toggleFilters() {
        this.showFilters = !this.showFilters;
    };

    private isMobileViewport(): boolean {
        return this.window.innerWidth <= 767;
    }

    toggleFilterPanel (item) {
        ($('#' + item) as any).collapse('toggle');
    };

    /*
        If there's at least one package for which the user is and
        admin of, then show the "Add Release" button
     */
    showAddReleaseButton () {
        let frsPackage = _.find(this.projectPackages, (item: any) => {
            return this.packageModel.acl.isAdmin(item);
        });

        return !_.isEmpty(frsPackage);
    };

    showEditReleaseIcon (release) {
        return this.showEditPackageIcon(release.package);
    };

    /* START: MODAL DIALOG HANDLING METHODS */
    showFiles (release) {
        const modalRef = this.modalService.open(FrsReleaseFilesComponent);
        modalRef.componentInstance.release = release;
        modalRef.componentInstance.close.subscribe(() => {
            modalRef.close();
        });
    };

    showEditPackage (_package, $e) {
        $e.preventDefault();
        $e.stopPropagation();

        const modalRef = this.modalService.open(FrsPackageEditComponent);
        modalRef.componentInstance.frspackage = _package;
        modalRef.componentInstance.close.subscribe((saved) => {
            modalRef.close();
            if (saved) {
                this.frsPackageService.fetch(
                    this.stateService.params.unixName
                ).then(
                    (result) => {
                        this.projectPackages = _.get(result, 'items', []);
                        this.getReleases();
                        this.getRecentReleases();
                    }, 
                    (response) => { console.log(response); }
                );
            }
        });
    };

    showAddPackage ($e) {
        var _package = {
            id: 0,
            isVisible: 'N',
            isPublic: 'N',
            requireLogin: 'Y',
            project: { id: this.project.id }
        };
        this.showEditPackage(_package, $e);
    };

    showAddRelease ($e) {
        var release = {
            id: 0,
            isReleased: 'N',
            isVisible: 'Y',
            preformatted: 'N',
            package: {
                id: 0,
                project: this.project.id
            }
        };
        this.showEditRelease(release, $e);
    };

    showEditRelease (release, $e) {
        $e.preventDefault();
        $e.stopPropagation();

        const modalRef = this.modalService.open(FrsReleaseEditComponent);
        modalRef.componentInstance.project = this.project;
        modalRef.componentInstance.release = release;
        modalRef.componentInstance.close.subscribe((result) => {
            modalRef.close();

            if (result) {
                this.getReleases();
                this.getRecentReleases();
            }
        });
    };
    /* END: MODAL DIALOG HANDLING METHODS */

    setFilterValues() {
        this.filters = {
            main_fields: this.filterService.setFilterValues(_.cloneDeep(this.baseFilters))
        };

        this.anyFiltersSet = this.filterService.anyFiltersSet(_.cloneDeep(this.baseFilters));
    }

    getReleases() {
        this.releases = false;
        var fetchArgs = this.filterService.getFetchArgs({ rel: 'files' });
        this.anyFiltersSet = this.filterService.anyFiltersSet(this.baseFilters);

        this.frsReleaseService.fetch(fetchArgs.unixName, fetchArgs)
            .then((response) => {
                this.releases = this.addShowDownloads(
                    this.addDownloadCounts(
                        _.get(response, 'items', [])
                    )
                );
            }, (response) => {
                console.log(response);
                this.releases = [];
            });
    }

    getRecentReleases() {
        this.recentReleases = false;

        this.frsReleaseService.getRecent(this.stateService.params.unixName)
            .then((response) => {
                this.recentReleases = this.addShowDownloads(
                    this.addDownloadCounts(
                        _.get(response, 'items', [])
                    )
                );
            }, (response) => {
                console.log(response);
                this.recentReleases = [];
            });
    }

    applyFilters(overrides = {}) {
        var newParams = _.pickBy(Object.assign(
            { unixName: this.stateService.params.unixName },
            this.sort,
            this.paging,
            this.filterService.getFilterValues(
                _.get(this.filters, 'main_fields', [])
            ),
            overrides
        ), function (value) {
            return (undefined != value && null != value && value != '');
        });

        this.stateService.go('.', newParams, { inherit: false }).then(
            () => {
                this.setFilterValues();
                this.getReleases();
            }
        );
    }

    updateFilters (changes) {
        this.applyFilters(changes);
    };

    addShowDownloads(releases) {
        return _.map(releases, (release) => {
            release.showDownload = this.showDownload(release);
            return release;
        });
    }

    showDownload(release) {
        // Admins always see the downloads
        // Check FRS project level and for this package
        if (_.get(this.projectMenu, 'frs', 0) > 1 ||
            _.get(this.projectMenu, 'packages.' + release.package.id, 0) > 1) {
            return true;
        }

        // Non-admin project members see released downloads
        // regardless of package public/private status
        if ((_.get(this.projectMenu, 'frs', 0) > 0 ||
            _.get(this.projectMenu, 'packages.' + release.package.id, 0) > 0) &&
            release.isReleased == 'Y') {
            return true;
        }

        // If the user has no specific access, 
        // check public and visible and released flags

        // If the package is neither public nor visible,
        // this user can't see any releases.
        if (release.package.isPublic != 'Y' ||
            release.package.isVisible != 'Y') {
                return false;
        }

        // If the package is visible,
        // can the user see this release?
        return (release.isVisible == 'Y' &&
                release.isReleased == 'Y');
    };

    addDownloadCounts(releases) {
        return _.map(releases, (release) => {
            release.downloadCount = this.releaseModel.getDownloadCount(release);
            return release;            
        });
    }
};